import Config from '@config';
import { observer, Provider } from 'mobx-react';
import { runInAction } from "mobx";
import React, { Suspense } from 'react';
import { RouterStore } from '@superwf/mobx-react-router';
import { createBrowserHistory } from 'history';
import { Route, Routes, BrowserRouter } from 'react-router-dom';

import { MainContent } from 'telia-front-react/main';
import { Overlay } from 'telia-front-react/overlay';
import RootStore from '@stores/RootStore';
import ComponentErrorBoundary from '@error/ComponentErrorBoundary';
import HeaderContainer from '@header/HeaderContainer';
import FooterContainer from '@footer/FooterContainer';
import NotFound from '@component/NotFound';
import TeliaLabelProvider from '@container/TeliaLabelProvider';
import TeliaThemeProvider from '@container/TeliaThemeProvider';
import Disturbance from '@disturbance/Disturbance';
import MainWrapper from "@container/MainWrapper";

const browserHistory = createBrowserHistory();

@observer
class App extends React.Component<any> {
  private rootStore: RootStore;

  constructor(props: any) {
    super(props);
    const routerStore = new RouterStore(browserHistory);
    runInAction(() => {
      this.rootStore = new RootStore(routerStore);
    });
  }

  public render() {
    const basePath = '/:lang?';

    if (!this.rootStore.translateStore.globalTranslations || !this.rootStore.ssoStore.isSsoLoaded) {
      return null;
    }

    const Redirector = (props: { url: string }): React.ReactElement => {
      setTimeout(() => window.location.assign(props.url), 0);
      return null;
    };

    return (
      <Provider {...this.rootStore}>
        <BrowserRouter>
          <TeliaThemeProvider>
            <TeliaLabelProvider>
              <MainWrapper>
                <HeaderContainer/>
                <ComponentErrorBoundary>
                  <MainContent>
                    <Suspense fallback={<Overlay spinner={true} />}>
                      <Routes>
                        <Route path={basePath} element={<Redirector url={Config.teliaSelfServiceUrl} />} />
                        <Route path={`${basePath}/katkestused`} element={<Disturbance />} />
                        <Route path={`${basePath}/404`} element={<NotFound />} />
                      </Routes>
                    </Suspense>
                  </MainContent>
                </ComponentErrorBoundary>
                <FooterContainer/>
              </MainWrapper>
            </TeliaLabelProvider>
          </TeliaThemeProvider>
        </BrowserRouter>
      </Provider>
    );
  }
}

export default App;
